<main class="text-start">
  <h1 class="page-title">{{ 'settings.title' | translate }}</h1>

  <div *ngIf="originalVendorDetails && modifiedVendorDetails; else settingsSkeleton"
    class="w-full bg-[#F6F6F6] rounded-lg p-3.5 flex max-md:flex-col justify-center max-md:items-center gap-16 md:gap-4">
    <div class="w-full h-full bg-white rounded-lg p-3.5 space-y-6">

      <div>
        <div></div>

        <div class="space-y-3">
          <p class="text-lg font-semibold"> {{ 'settings.section.basic_settings' | translate }} </p>
          <p class="text-sm"> {{ 'settings.section.basic_settings_description' | translate }} </p>
        </div>
      </div>

      <div class="flex max-md:flex-col gap-4">
        <div class="flex-1 min-w-0">
          <!-- Logo Input -->
          <app-image-uploader [productImages]="modifiedVendorDetails.logo ? [modifiedVendorDetails.logo] : []"
            [maxImages]="1" type="vendor-logo" [title]="'settings.labels.logo' | translate" (imagesChange)="modifiedVendorDetails.logo= $event[0]">
          </app-image-uploader>
        </div>

        <div class="flex-1 min-w-0">
          <!-- Banner Input -->
          <app-image-uploader [productImages]="modifiedVendorDetails.banner_image ? [modifiedVendorDetails.banner_image] : []"
            [maxImages]="1" type="banner" [title]="'settings.labels.banner' | translate" (imagesChange)="modifiedVendorDetails.banner_image= $event[0]">
          </app-image-uploader>
        </div>
      </div>

      <div>
        <form #settingsForm="ngForm" (submit)="submit()" class="bg-white rounded-xl px-5 py-5 mt-3 items-center w-full">

          <!-- Store Name Input -->
          <div class="input-group-row">
            <div class="generic-input-group">
              <label for="store_name_ar"> <span class="text-red-500">*</span>{{ 'settings.labels.store_name_ar' | translate }}</label>
              <input dir="auto" type="text" name="store_name_ar" id="store_name_ar"
                [(ngModel)]="modifiedVendorDetails.shop_name_ar" required />
            </div>

            <div class="generic-input-group">
              <label for="store_name_en"> <span class="text-red-500">*</span>{{ 'settings.labels.store_name_en' | translate }}</label>
              <input dir="ltr" type="text" name="store_name_en" id="store_name_en"
                [(ngModel)]="modifiedVendorDetails.shop_name_en" required />
            </div>
          </div>


          <div class="input-group-row">
            <!-- Owner Name Input -->
            <div class="generic-input-group">
              <label for="owner_name_ar"> <span class="text-red-500">*</span> {{ 'settings.labels.owner_name_ar' | translate }} </label>
              <input dir="auto" type="text" name="owner_name_ar" id="owner_name_ar" disabled class="cursor-not-allowed"
                [(ngModel)]="modifiedVendorDetails.shop_owner_name_ar" required />
            </div>
            <div class="generic-input-group">
              <label for="owner_name_en"> <span class="text-red-500">*</span> {{ 'settings.labels.owner_name_en' | translate }} </label>
              <input dir="ltr" type="text" name="owner_name_en" id="owner_name_en" disabled class="cursor-not-allowed"
                [(ngModel)]="modifiedVendorDetails.shop_owner_name_en" required />
            </div>
          </div>

          <div class="input-group-row">
            <!-- Email Input -->
            <div class="generic-input-group">
              <label for="email"> <span class="text-red-500">*</span>{{ 'settings.labels.email' | translate }}</label>
              <input dir="ltr" type="text" name="email" id="email" [(ngModel)]="modifiedVendorDetails.email" required />
            </div>

            <!-- Phone Number Input -->
            <div class="generic-input-group">
              <label for="phone_number"> <span class="text-red-500">*</span>{{ 'settings.labels.phone_number' | translate }}</label>
              <input dir="ltr" type="text" name="phone_number" id="phone_number"
                [(ngModel)]="modifiedVendorDetails.phone_number" required />
            </div>
          </div>

          <div class="w-full grid grid-cols-1 md:grid-cols-3 gap-3">
            <!-- Country -->
            <div class="generic-input-group">
              <label for="country"> <span class="text-red-500">* </span>{{ 'settings.labels.country' | translate }}</label>
              <input dir="auto" type="text" name="country" id="country" [(ngModel)]="modifiedVendorDetails.country"
                required />
            </div>

            <!-- City -->
            <div class="generic-input-group">
              <label for="city"> <span class="text-red-500">* </span>{{ 'settings.labels.city' | translate }}</label>
              <input dir="auto" type="text" name="city" id="city" [(ngModel)]="modifiedVendorDetails.city" required />
            </div>

            <!-- Neighborhood -->
            <div class="generic-input-group">
              <label for="neighborhood"> <span class="text-red-500">* </span>{{ 'settings.labels.neighborhood' | translate }}</label>
              <input dir="auto" type="text" name="neighborhood" id="neighborhood"
                [(ngModel)]="modifiedVendorDetails.neighborhood" required />
            </div>
          </div>

          <!-- Address Input -->
          <div class="generic-input-group">
            <label for="address"> <span class="text-red-500">*</span>{{ 'settings.labels.address' | translate }}</label>
            <input dir="auto" type="text" name="address" id="address" [(ngModel)]="modifiedVendorDetails.address"
              required />
          </div>

          <!-- Commercial Number Input -->
          <div class="generic-input-group">
            <label for="commercial_number"> <span class="text-red-500">*</span><span class="text-[#6C6C89]">
              </span>{{ 'settings.labels.commercial_number' | translate }} </label>
            <input dir="auto" type="text" name="commercial_number" id="commercial_number" class="cursor-not-allowed"
              [(ngModel)]="modifiedVendorDetails.commercial_registration_number" disabled />
          </div>

          <!-- Is Temporarily Closed Checkbox -->
          <div class="generic-input-group flex items-center justify-start gap-2 mt-6">
            <input
              id="is_temporarily_closed"
              type="checkbox"
              name="is_temporarily_closed"
              [(ngModel)]="modifiedVendorDetails.is_temporarily_closed"
              class="w-3.5! h-3.5! mt-0! cursor-pointer accent-[#611F79] rounded-md!"
            />
            <label for="is_temporarily_closed" class="flex items-center gap-3 cursor-pointer w-fit text-sm text-[#121217]">
                {{ 'settings.temp_closed.label' | translate }}
            </label>
            <p *ngIf="modifiedVendorDetails.is_temporarily_closed" class="text-xs text-red-500">
                {{ 'settings.temp_closed.warning' | translate }}
            </p>
          </div>

          <div class="-mt-2">
            <span class="text-[#121217] text-sm"> <span class="text-red-500">*</span>{{ 'settings.labels.location' | translate }}</span>
            <div class="mt-2"></div>
            <app-google-map [pickPoint]="true" [latitude]="modifiedVendorDetails.latitude"
              [longitude]="modifiedVendorDetails.longitude" [zoom]="13" height="200px"
              (pointSelected)="onPointPicked($event)" markerTitle="delivery address"></app-google-map>
          </div>

          <div class="mt-5">
            <span class="text-[#121217] text-sm"> <span class="text-red-500">*</span>{{ 'settings.labels.working_hours' | translate }}</span>
            <div class="overflow-x-auto max-w-full mt-1">

              <table class="working-hours-table">
                <thead>
                  <tr>
                    <th>{{ 'settings.working_hours_table.day' | translate }}</th>
                    <th>{{ 'settings.working_hours_table.open' | translate }}</th>
                    <th>{{ 'settings.working_hours_table.opening' | translate }}</th>
                    <th>{{ 'settings.working_hours_table.closing' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let workingHours of modifiedVendorDetails.working_hours; let i = index">
                    <td>{{ weekDays[workingHours.weekday].name | translate }}</td>
                    <td class="flex items-center gap-2">
                      <p>{{ 'settings.working_hours_table.close_label' | translate }}</p>
                      <div class="relative inline-flex items-center cursor-pointer select-none"
                        (click)="workingHours.is_open= !workingHours.is_open">
                        <div class="w-8 h-4 rounded-full transition-colors duration-300"
                          [ngClass]="workingHours.is_open ? 'bg-green-500' : 'bg-gray-300'">
                        </div>
                        <div
                          class="absolute start-0.5 top-0.5 w-3 h-3 bg-white rounded-full transition-transform duration-300"
                          [ngStyle]="{ transform: workingHours.is_open ? (languageService.isRtl() ? 'translateX(-16px)' : 'translateX(16px)') : 'translateX(0)' }">
                        </div>
                      </div>
                      <p>{{ 'settings.working_hours_table.open_label' | translate }}</p>
                    </td>
                    <td>
                      <input class="bg-white focus:border-gray-300 px-2 py-1.5
                      border outline-none border-gray-200 rounded-md disabled:text-gray-300" type="time"
                        [(ngModel)]="workingHours.open_time" name="open_{{i}}" [disabled]="!workingHours.is_open"
                        [ngClass]="showWorkingHoursErrors && workingHours.is_open && workingHours.open_time.trim() == '' ? 'border-red-500' : ''">
                    </td>
                    <td>
                      <input class="bg-white focus:border-gray-300 px-2 py-1.5
                      border outline-none border-gray-200 rounded-md disabled:text-gray-300" type="time"
                        [(ngModel)]="workingHours.close_time" name="close_{{i}}" [disabled]="!workingHours.is_open"
                        [ngClass]="showWorkingHoursErrors && workingHours.is_open && workingHours.close_time.trim() == '' ? 'border-red-500' : ''">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="flex max-sm:flex-col justify-end gap-3">
            <button type="button" class="flex justify-center items-center gap-3
                text-gray-800 disabled:text-gray-500 text-xs
                rounded-lg px-6 py-2 mt-2 border border-gray-300
                cursor-pointer disabled:cursor-auto" [disabled]="!areDataModified() || disableButtons"
              (click)="cancel()">
              {{ 'settings.actions.cancel' | translate }}
            </button>

            <button type="submit" class="flex justify-center items-center gap-2 bg-[#611F79]
                text-white text-xs rounded-lg px-5 py-2 mt-2 disabled:opacity-60
                cursor-pointer disabled:cursor-auto" [disabled]="!areDataModified() || disableButtons">
              <span *ngIf="loading" class="w-3 h-3 border border-t-0 border-white rounded-full animate-spin"></span>
              {{ 'settings.actions.save' | translate }}
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>

  <ng-template #settingsSkeleton>
    <div class="w-full bg-[#F6F6F6] rounded-lg p-3.5 animate-pulse">
      <div class="w-full bg-white rounded-lg p-4 space-y-6">

        <div class="space-y-3">
          <div class="h-6 w-48 bg-gray-200 rounded"></div>
          <div class="h-4 w-72 bg-gray-100 rounded"></div>
        </div>

        <div class="flex max-md:flex-col gap-4">
          <div class="flex-1 h-48 rounded-xl bg-gray-200"></div>
          <div class="flex-1 h-48 rounded-xl bg-gray-200"></div>
        </div>

        <div class="space-y-5">

          <div class="grid md:grid-cols-2 gap-4">
            <div>
              <div class="h-4 w-40 mb-2 bg-gray-200 rounded"></div>
              <div class="h-11 bg-gray-100 rounded-lg"></div>
            </div>

            <div>
              <div class="h-4 w-40 mb-2 bg-gray-200 rounded"></div>
              <div class="h-11 bg-gray-100 rounded-lg"></div>
            </div>
          </div>

          <div class="grid md:grid-cols-2 gap-4">
            <div>
              <div class="h-4 w-48 mb-2 bg-gray-200 rounded"></div>
              <div class="h-11 bg-gray-100 rounded-lg"></div>
            </div>

            <div>
              <div class="h-4 w-48 mb-2 bg-gray-200 rounded"></div>
              <div class="h-11 bg-gray-100 rounded-lg"></div>
            </div>
          </div>

          <div class="grid md:grid-cols-2 gap-4">
            <div class="h-11 bg-gray-100 rounded-lg"></div>
            <div class="h-11 bg-gray-100 rounded-lg"></div>
          </div>

          <div class="grid md:grid-cols-3 gap-4">
            <div class="h-11 bg-gray-100 rounded-lg"></div>
            <div class="h-11 bg-gray-100 rounded-lg"></div>
            <div class="h-11 bg-gray-100 rounded-lg"></div>
          </div>

          <div class="h-11 bg-gray-100 rounded-lg"></div>

          <div class="h-11 bg-gray-100 rounded-lg"></div>

          <div class="flex justify-start">
            <div class="w-40 h-5 bg-gray-100 rounded"></div>
          </div>

          <div class="space-y-3">
            <div class="h-5 w-28 bg-gray-200 rounded"></div>
            <div class="h-[200px] bg-gray-100 rounded-xl"></div>
          </div>

          <div class="space-y-3">
            <div class="h-5 w-32 bg-gray-200 rounded"></div>

            <div class="border border-gray-100 rounded-xl overflow-hidden">
              <div *ngFor="let item of [1,2,3,4,5,6,7]" class="grid grid-cols-4 gap-4 p-3 border-b border-gray-100">

                <div class="h-8 bg-gray-100 rounded"></div>
                <div class="h-8 bg-gray-100 rounded"></div>
                <div class="h-8 bg-gray-100 rounded"></div>
                <div class="h-8 bg-gray-100 rounded"></div>
              </div>
            </div>
          </div>

          <div class="flex gap-3">
            <div class="h-10 w-32 rounded-lg bg-gray-200"></div>
            <div class="h-10 w-32 rounded-lg bg-gray-100"></div>
          </div>

        </div>
      </div>
    </div>
  </ng-template>

</main>
